import { api } from "../services/Api";

export default async function salvaHistoricoLog(
  acao,
  pedido,
  rastreador,
  dados,
  excluido
) {
  const usuario = localStorage.getItem("@DNACenter:codigoUsuario");
  try {
    await api.post("/v2/coleta/coletaLog", {
      pedido: String(pedido || ""),
      usuario: String(usuario || ""),
      acao: String(acao || ""),
      rastreador: String(rastreador || ""),
      dados: String(dados || ""),
      excluido: Boolean(excluido || false),
    });
  } catch (error) {
    console.error("Erro ao salvar log:", error);
  }
}